export default __webpack_public_path__ + "static/media/Indicator.5c7b54c7.svg";